import { NavLink } from 'react-router-dom';
import { useDataContext } from 'context/DataStoreContext';
import { useAuth } from 'model/Auth';
import { permissions, Permission } from 'model/Role';
import { hasPermission } from 'model/Route';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import H2 from 'component/part/H2';
import List, { ListIndex } from 'component/part/List';

const roleIndexes: ListIndex[] = [
  { label: '役職名', key: 'name' },
  { label: '権限' },
];

const permissionLabelMap: { [code in Permission]: string } = permissions.reduce(
  (acc, { code, label }) => ({ ...acc, [code]: label }),
  {} as { [code in Permission]: string },
);

const style = {
  permissionList: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    gap: '0.4rem 0.8rem',
    fontSize: '1.2rem',
  },
  permissionTag: {
    padding: '0.1rem 0.6rem',
    backgroundColor: '#eef0f4',
    borderRadius: '0.4rem',
  },
};

const RoleList: React.FC = () => {
  const { state } = useDataContext();
  const { list = [] } = state?.role || {};
  const { user: owner } = useAuth();
  const enableEdit = owner && hasPermission('role', 'edit', owner.role);

  const rows = list.map((role) => [
    <NavLink to={`/role/${role.id}/edit`} css={generalStyle.link}>{role.name}</NavLink>,
    <div css={style.permissionList}>
      {permissions
        .filter(({ code }) => role.permissions[code])
        .map(({ code }) => (
          <span key={code} css={style.permissionTag}>{permissionLabelMap[code]}</span>
        ))}
    </div>,
  ]);

  return <Layout>
    <BackLink link='/' label='トップ'></BackLink>
    <H2>役職一覧</H2>
    <div css={generalStyle.listLayout}>
      <List
        type='role'
        indexes={roleIndexes}
        rows={rows}
      />
      {enableEdit && (
        <div css={generalStyle.formRow}>
          <NavLink to='/role/create' css={generalStyle.button()}>新規登録</NavLink>
        </div>
      )}
    </div>
  </Layout>;
};

export default RoleList;
